function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { PureComponent, Fragment } from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import IconButton from "@mui/material/IconButton";
import NotesIcon from "@mui/icons-material/Notes";
import TestimonialIcon from "@mui/icons-material/RecordVoiceOver";
import FeedbackIcon from "@mui/icons-material/Feedback";
//Limitless imports
import InfoDialog from "../info-dialog/InfoDialog";
const ICON_MAP = {
  notes: NotesIcon,
  testimonial: TestimonialIcon,
  feedback: FeedbackIcon
};
class MessageNotesDialog extends PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      showNotesDialog: false
    });
    _defineProperty(this, "handleOpenNotes", event => {
      event.stopPropagation();
      this.setState({
        showNotesDialog: true
      });
    });
    _defineProperty(this, "handleCloseNotes", event => {
      event.stopPropagation();
      this.setState({
        showNotesDialog: false
      });
    });
  }
  render() {
    const {
      classes,
      notes,
      title,
      iconType
    } = this.props;
    const {
      showNotesDialog
    } = this.state;
    let Icon = ICON_MAP[iconType];
    Icon = Icon ? Icon : ICON_MAP["notes"];
    return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(IconButton, {
      color: "secondary",
      onClick: this.handleOpenNotes,
      size: "large"
    }, /*#__PURE__*/React.createElement(Icon, {
      color: "secondary",
      fontSize: "small"
    })), showNotesDialog && /*#__PURE__*/React.createElement(InfoDialog, {
      headerText: title,
      informationText: notes,
      onCancelClick: this.handleCloseNotes,
      classes: classes,
      fullWidth: true
    }));
  }
}
const styles = () => ({
  contentTextRoot: {
    whiteSpace: "pre-wrap"
  }
});
export default withStyles(styles)(MessageNotesDialog);
MessageNotesDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  notes: PropTypes.string.isRequired,
  title: PropTypes.string,
  iconType: PropTypes.string
};
MessageNotesDialog.defaultNotes = {
  title: "Notes",
  iconType: "notes"
};